import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import NotificationCardItem from "../../components/NotificationCardItem";
import { useNavigate } from "react-router";
import { setItem } from "../../utils/DataProtection";
import NotificationOnHoverUI from "./NotificationOnHoverUI";

export function SortableItem({colId, id, item, showEquipment,handleUserClick }) {

  const navigate = useNavigate();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    borderRadius: "6px",
    backgroundColor: isDragging ? "#d1e3ff" : "#fff",
    boxShadow: isDragging
      ? "2px 2px 5px 2px rgba(0,0,0,0.15)"
      : "2px 2px 5px 2px rgba(0,0,0,0.05)",
    cursor: "grab",
    margin: "0px 1px 1px 0px"
  };

  const handleNotificationClick = (item) => {
    setItem("notification-nodeid", item?.nodeid);
    navigate("/notification-details", {
      state: {
        nodeid: item?.nodeid,
        equipmentNodeId:
          item?.equipmentnodeid,
        from: "aufgabenplanung",
      }
    });
  }

  return (
    <div onClick={() => handleNotificationClick(item)} ref={setNodeRef} style={style} {...attributes}  {...listeners} key={`${id}`}
      id={`${id}`}
    >
      {Object.keys({ notification: item }).length ? <NotificationCardItem data={{ notification: item }} showEquipment={showEquipment} onHoverUI={<NotificationOnHoverUI notificationnodeid={item.nodeid} notificationusernodeid={colId} handleUserClick={handleUserClick}/>}/> : ""}
    </div>
  );
}
